import { defineStore } from "pinia";
import { BASE_URL } from "@/package/config/main-api";
import * as userApi from "../api/user-api";
import { ITotp, IUser } from "../types/frontend-types";
import { errorHandler } from "@/package/global-helpers/error-handler";
import { useCookies } from "@vueuse/integrations/useCookies";
import { getCurrentDomain } from "@/package/global-helpers/system-country";

const cookies = useCookies();

export const useUserStore = defineStore("user-store", {
  state: () => ({
    user: null as null | IUser,
    cardNumber: null as null | string,
    userTotp: null as null | ITotp,
  }),

  actions: {
    authUser() {
      localStorage.setItem("lastVisitPage", window.location.pathname);
      window.open(`${BASE_URL}api/v2/oauth/redirect`, "_self");
    },

    exitUser() {
      cookies.remove("ksUserToken", {
        path: "/",
        domain: getCurrentDomain(),
      });
      cookies.remove("ksUserRefresh", {
        path: "/",
        domain: getCurrentDomain(),
      });
      window.location.reload();
    },

    async loadUserInformation() {
      try {
        const resp = await userApi.apiGetUserInformation();
        this.user = resp.data.data.user;
      } catch (error: Error | unknown) {
        errorHandler(error, true);
        throw error;
      }
    },

    setUserPromoCode(code: string) {
      this.user.promocode = code;
    },

    async loadUserTotp() {
      try {
        const resp = await userApi.apiGetUserTotp();
        this.cardNumber = resp.data.data.card_number;
        this.userTotp = resp.data.data.totp;
      } catch (error: Error | unknown) {
        errorHandler(error, false);
        throw error;
      }
    },

    async urlRedirect(params: any) {
      try {
        const resp = await userApi.apiUrlRedirect(params);
        return resp.data.data.redirect_to;
      } catch (error: Error | unknown) {
        errorHandler(error, false);
        throw error;
      }
    },

    clearUserTotp() {
      this.cardNumber = null;
      this.userTotp = null;
    },

    async setToggleFeature(feature: string) {
      try {
        const resp = await userApi.apiSetToggleFeature(feature);
        this.user.features = resp.data.data.features;
      } catch (error: Error | unknown) {
        errorHandler(error, true);
        throw error;
      }
    },
  },
});
